import { IsString, IsUUID } from "class-validator";
import { AssessmentStatusCode } from "../../../../common/codes.types";

export class AdminUpdateAssessmentStatusPayload {
    @IsString()
    assessmentStatusCode: AssessmentStatusCode;
}